// extracted by mini-css-extract-plugin
module.exports = {"overview-container":"terms-TermsOverview-overview-container-bbd95cd4","overviewContainer":"terms-TermsOverview-overview-container-bbd95cd4"};